"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoType = exports.ProductIDQuantity = exports.LoyaltyRequirement = exports.PurchaseRequirement = exports.ProductQuantity = void 0;
var ts_money_1 = require("ts-money");
var Product_1 = __importDefault(require("./Product"));
var ProductVariant_1 = __importDefault(require("./ProductVariant"));
var Promo = /** @class */ (function () {
    function Promo(json) {
        this.id = json.id;
        this.name = json.name;
        this.description = json.description;
        this.promoType = json.promoType;
        this.awardValidityDays = json.awardValidityDays;
        this.awardedProductQuantities = json.awardedProductQuantities.map(function (json) { return new ProductQuantity(json); });
        if (json.loyaltyRequirement) {
            this.loyaltyRequirement = new LoyaltyRequirement(json.loyaltyRequirement);
        }
        if (json.purchaseRequirement) {
            this.purchaseRequirement = new PurchaseRequirement(json.purchaseRequirement);
        }
    }
    Object.defineProperty(Promo.prototype, Symbol.toStringTag, {
        get: function () {
            return 'Promo';
        },
        enumerable: false,
        configurable: true
    });
    return Promo;
}());
exports.default = Promo;
var ProductQuantity = /** @class */ (function () {
    function ProductQuantity(json) {
        this.quantity = json.quantity;
        if (typeof json.product == typeof Product_1.default) {
            this.product = json.product;
        }
        else {
            this.product = new Product_1.default(json.product);
        }
        if (typeof json.variant == typeof ProductVariant_1.default) {
            this.variant = json.variant;
        }
        else if (json.variant != null) {
            this.variant = new ProductVariant_1.default(json.variant);
        }
        else {
            this.variant = null;
        }
        this.isVehicleRestricted = json.isVehicleRestricted;
    }
    Object.defineProperty(ProductQuantity.prototype, Symbol.toStringTag, {
        get: function () {
            return 'ProductQuantity';
        },
        enumerable: false,
        configurable: true
    });
    return ProductQuantity;
}());
exports.ProductQuantity = ProductQuantity;
var PurchaseRequirement = /** @class */ (function () {
    function PurchaseRequirement(json) {
        this.normalPrice = ts_money_1.Money.fromInteger(json.normalPrice, ts_money_1.Currencies.MYR);
        this.memberPrice = ts_money_1.Money.fromInteger(json.memberPrice, ts_money_1.Currencies.MYR);
        this.productID = json.productID;
    }
    Object.defineProperty(PurchaseRequirement.prototype, Symbol.toStringTag, {
        get: function () {
            return 'PurchaseRequirement';
        },
        enumerable: false,
        configurable: true
    });
    return PurchaseRequirement;
}());
exports.PurchaseRequirement = PurchaseRequirement;
var LoyaltyRequirement = /** @class */ (function () {
    function LoyaltyRequirement(json) {
        this.timeLimitDays = json.timeLimitDays;
        this.invoicesRequired = json.invoicesRequired;
        this.validProducts = json.validProducts;
    }
    Object.defineProperty(LoyaltyRequirement.prototype, Symbol.toStringTag, {
        get: function () {
            return 'QualifyingProductQuantity';
        },
        enumerable: false,
        configurable: true
    });
    return LoyaltyRequirement;
}());
exports.LoyaltyRequirement = LoyaltyRequirement;
var ProductIDQuantity = /** @class */ (function () {
    function ProductIDQuantity(productID, variantID, quantity, isVehicleRestricted) {
        this.quantity = quantity;
        this.variantID = variantID;
        this.productID = productID;
        this.isVehicleRestricted = isVehicleRestricted;
    }
    return ProductIDQuantity;
}());
exports.ProductIDQuantity = ProductIDQuantity;
var PromoType = /** @class */ (function () {
    function PromoType(id, name, description) {
        this.id = id;
        this.name = name;
        this.description = description;
    }
    PromoType.Invalid = new PromoType('invalid', 'Select a promo type:', '');
    PromoType.Purchase = new PromoType('purchase', 'Pre-purchase', 'The customer pays in advance for a bundle of products which they can claim at a later date');
    PromoType.Loyalty = new PromoType('loyalty', 'Loyalty', 'The customer is awarded products if they purchase all the specified products within the specified time period');
    PromoType.byID = function (promoTypeID) {
        switch (promoTypeID) {
            case PromoType.Purchase.id:
                return PromoType.Purchase;
            case PromoType.Loyalty.id:
                return PromoType.Loyalty;
            default:
                return PromoType.Invalid;
        }
    };
    PromoType.All = [PromoType.Invalid, PromoType.Purchase, PromoType.Loyalty];
    return PromoType;
}());
exports.PromoType = PromoType;
